<template>
    <div>
        <ticRadio
            @input="handleInputValue($event,'selected')"
            :options="optionsRadio"
            :value="fieldsValues[id].selected"
            :classList="'d-flex justify-content-center'"
            :buttons="true"
        />
        <div v-if="fieldsValues[id].selected !== ''" class="mt-4">
            <component
                @input="handleInputValue($event, fieldsValues[id]['selected'])"
                :is="'tic' + fields[fieldsValues[id]['selected']].component.charAt(0).toUpperCase() + fields[fieldsValues[id]['selected']].component.slice(1)"
                :value="fieldsValues[id][fieldsValues[id].selected]"
                v-bind="fields[fieldsValues[id].selected].params"
            >
            </component>
        </div>
    </div>
</template>
<script>
import ticTextInfo from '@/components/formation/offline/textInfo'
import ticText from '@/components/frontoffice/form/baseInput/text'
import ticSelect from '@/components/frontoffice/form/baseInput/selectBVue'
import ticCheckboxGroup from '@/components/frontoffice/form/baseInput/checkboxBVue'
import ticRadio from '@/components/frontoffice/form/baseInput/radioBVue'
import ticSingleRadio from '@/components/frontoffice/form/baseInput/singleRadioBVue'

import ticRooms from '@/components/formation/form/offline/rooms'
import ticPaymentMethodCB from '@/components/formation/form/offline/paymentMethodCB.vue'
export default {
  components: {
    ticTextInfo,
    ticText,
    ticSelect,
    ticCheckboxGroup,
    ticRadio,
    ticSingleRadio,
    ticRooms,
    ticPaymentMethodCB
  },
  data () {
    return {
      fieldsValues: {},
      optionsRadio: [],
      checked: ''
    }
  },
  props: {
    fields: {
      type: Object
    },
    id: {
      type: String
    },
    value: {
      type: [Object, String]
    }
  },
  methods: {
    handleInputValue (value, index) {
      this.$set(this.fieldsValues[this.id], index, value)
      this.$emit('input', this.fieldsValues)
    },
    setUpOptionsRadio () {
      for (let [key, field] of Object.entries(this.fields)) {
        let obj = {
          text: field.params.text,
          value: field.params.value
        }
        this.optionsRadio.push(obj)
      }
    }
  },
  created () {
    if (this.value != '') {
      this.fieldsValues = this.value
    } else {
      this.$set(this.fieldsValues, this.id, {})
      this.$set(this.fieldsValues[this.id], 'selected', '')
      for (let [key, field] of Object.entries(this.fields)) {
        if (!field.hasOwnProperty('dontSave')) {
          this.$set(this.fieldsValues[this.id], field.id, '')
        }
      }
    }
    this.setUpOptionsRadio()
  }
}
</script>
<style scoped>

</style>
